import React from "react"
import { concatClassNames } from "helpers/jsxHelpers"
import "./index.scss"

interface ContainerProps {
	className?: string
	children: React.ReactNode
}

const Container: React.FC<ContainerProps> = ({ children, className }) => (
	<div className={concatClassNames(["main-container", className])}>
		{children}
	</div>
)

export default Container
